import { defineComponent } from "vue";
import common from "../core/core";

export default defineComponent({
  data() {
    return {
      addressService: this.$store.direct.getters.addressService,
      searchOpened: false,
      mobileMenuOpened: false,
      searchText: "",
      activeMenuIndex: null,
      pageScroll: 0,
      experimentVariant: null,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      this.onPageScroll();
    });
    this.onPageScroll();
  },
  methods: {
    closeSearch(e: any) {
      this.searchOpened = false;
      this.clearSearch();
    },
    onPageScroll() {
      const newPageScroll = (window.pageYOffset || document.body.scrollTop) - (document.body.clientTop || 0);
      if (!this.pageScroll && newPageScroll) {
        document.getElementById("header").classList.add("scrolled");
      } else if (this.pageScroll && !newPageScroll) {
        document.getElementById("header").classList.remove("scrolled");
      }
      this.pageScroll = newPageScroll;
    },
    toggleSearch(value: boolean = null) {
      this.searchOpened = value === null ? !this.searchOpened : value;
    },
    toggleMobileMenu() {
      this.mobileMenuOpened = !this.mobileMenuOpened;
      document.body.classList[this.mobileMenuOpened ? "add" : "remove"]("mobile-scroll-lock");
    },
    openSearch() {
      this.searchOpened = true;
      setTimeout(() => {
        const input: any = this.$refs.headerInput;
        input.focus();
      }, 100);
    },
    clearSearch() {
      if (this.searchText) {
        this.searchText = "";
        this.searchOpened = false;
      }
    },
    toggleOverallSearch() {
      window.location.href = "/vyhledavani/?query=" + encodeURI(this.searchText) + "&page_number=1";
      // window.location.reload();
    },
    toggleMenuItem(index: number) {
      if (this.mobileMenuOpened) {
        this.activeMenuIndex = this.activeMenuIndex === index ? null : index;
      }
    },
    isMenuItemActive(index: number) {
      return this.activeMenuIndex === index;
    },
  },
  mixins: [common],
});
